<template>
  <div class="circular-icon">
    <icon :name="iconName" :variant="iconVariant" class="icon" />
  </div>
</template>

<script>
import Icon from '@/components/singletons/icon.vue';

export default {
  name: 'CircularIcon',
  components: { Icon },
  props: {
    iconName: {
      type: String,
      required: true,
    },
    iconVariant: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.circular-icon {
  align-items: center;
  background-color: white;
  border: 1px solid rgba(203, 206, 209, 1);
  border-radius: 50%;
  box-shadow: 0px 1.45px 2.91px -1.45px var(--ColorsEffectsShadowsshadow-sm02),
    0px 1.45px 4.36px 0px var(--ColorsEffectsShadowsshadow-sm01);
  box-sizing: border-box;
  display: flex;
  height: 24px;
  justify-content: center;
  width: 24px;

  .icon {
    height: 13px;
    width: 13px;
  }
}
</style>
